import React from "react";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../../revvComponents";

// import AddNewField from "./AddNewField";
import RevvField from "./RevvField";

// import { FORM_FIELD } from "../../../../constants/fields";

import SrcFieldMapperBlock from "./SrcFieldMapperBlock";

const RevvFieldMapperBlock = ({
  // fieldsList,
  // draggedType,
  // draggedFieldID,
  // draggedFieldSubType,
  // addFieldAllowed,
  revvFieldDefs,
  // addNewRevvField,
  addNewSourceField,
  // removeField,
  removeSrcField,
  sourceFields,
  saveMapping,
  // checkTransformPopup,
  openTransformPopup,
  deleteConnection,
  revvFieldIDsWithInternalField,
  metaFieldIDsWithInternalField,
  value,
  searchInput,
  filterState,
  tableIDsWithInternalField,
  signerIDsWithInternalField,
  objectFieldsMapping,
  showMenuType,
  cardName,
}) => {
  // To add 1. source field, 2. form field
  // 1. objectID, mappingIndex, sourceFieldName
  // 2. objectID, mappingIndex, formFieldID
  // const _addNewFormField = (formFieldID, ffSubType) => {
  // only 1 form field allowed
  //   addNewRevvField(formFieldID, ffSubType);
  // };

  // const _onDragOver = event => {
  //   event.preventDefault();
  // };

  // const _dropFormField = event => {
  //   event.preventDefault();
  //   if (addFieldAllowed && draggedType === FORM_FIELD) {
  //     _addNewFormField(draggedFieldID, draggedFieldSubType);
  //   }
  // };

  const _deleteConnection = revvField => {
    const objMapping = objectFieldsMapping.filter(obj => {
      if (obj.revvFieldID === revvField.id) {
        if (obj.revvSubField === null) {
          return obj;
        }
        if (obj.revvSubField === revvField.sub_field) {
          return obj;
        }
        return false;
      }
      return false;
    });

    if (Array.isArray(objMapping) && objMapping.length > 0) {
      deleteConnection(objMapping[0]);
    }
  };

  const _checkTransformPopup = (revvField, type) => {
    let objMapping;
    if (Array.isArray(objectFieldsMapping) && objectFieldsMapping.length > 0) {
      objMapping = objectFieldsMapping.filter(obj => {
        if (obj.revvFieldID === revvField.id) {
          if (obj.revvSubField === null) {
            return obj;
          }
          if (obj.revvSubField === revvField.sub_field) {
            return obj;
          }
          return false;
        }
        return false;
      });
    }
    if (Array.isArray(objMapping) && objMapping.length > 0) {
      const fieldMapping = objMapping[0];
      const sourceFields1 =
        fieldMapping &&
        fieldMapping.mapping &&
        Array.isArray(fieldMapping.mapping.source_fields)
          ? fieldMapping.mapping.source_fields
          : [];

      const revvFieldID = (fieldMapping && fieldMapping.revvFieldID) || null;
      // const revvSubField = revvFieldID ? fieldMapping.revvSubField : null;

      // const field =
      //   revvFieldID && Array.isArray(fieldsList)
      //     ? this.props.fieldsList.find(f => f.id === revvFieldID)
      //     : undefined;
      const checkTransformPopup = !!(
        Array.isArray(sourceFields1) &&
        sourceFields1.length > 0 &&
        revvFieldID
      );

      if (checkTransformPopup) {
        if (type === "click") openTransformPopup(fieldMapping);
        return checkTransformPopup;
      }
    }
    return false;
  };

  // let key = "";
  // let title = "";
  // if (revvFieldID && field) {
  //   key = revvSubField ? `${field.label}-${revvSubField}` : field.label;
  //   title = revvSubField ? `${field.label}.${revvSubField}` : field.label;
  // }
  let unusedRevvFields = [];
  if (cardName === "FORM") {
    unusedRevvFields = revvFieldIDsWithInternalField.map(
      fieldID => revvFieldDefs[fieldID],
    );
  } else if (cardName === "META_FIELD") {
    unusedRevvFields = metaFieldIDsWithInternalField.map(
      fieldID => revvFieldDefs[fieldID],
    );
  } else if (cardName === "SIGNATURE") {
    const signerValue = signerIDsWithInternalField.filter(element => {
      if (element.indexOf(value) !== -1) {
        return true;
      }
      return false;
    });
    unusedRevvFields = signerValue.map(fieldID => revvFieldDefs[fieldID]);
  } else if (cardName === "TABLE") {
    const tableValue = tableIDsWithInternalField.filter(element => {
      if (element.indexOf(value) !== -1) {
        return true;
      }
      return false;
    });
    const unsortedCols = tableValue.map(fieldID => revvFieldDefs[fieldID]);
    const tableField =
      Array.isArray(unsortedCols) &&
      unsortedCols.length > 0 &&
      revvFieldDefs[unsortedCols[0].id];
    if (tableField) {
      const {
        meta: {
          table: {
            table_schema: { column_order: columnOrder, label_map: labelMap },
          },
        },
      } = tableField;
      const sortedCols = [];
      columnOrder.forEach(colId => sortedCols.push(labelMap[colId].text));
      sortedCols.forEach((fieldText, index) => {
        const colField = unsortedCols.find(col => col.sub_field === fieldText);
        sortedCols[index] = colField;
      });
      unusedRevvFields = sortedCols;
    } else {
      unusedRevvFields = unsortedCols;
    }
  }
  return (
    <div className="revv-field-mapper-block-wrapper">
      {unusedRevvFields.map(item => (
        <div key={item.label} className="source-to-revvfield-mapping">
          <SrcFieldMapperBlock
            addFieldAllowed
            sourceFields={sourceFields}
            addNewField={addNewSourceField}
            removeField={removeSrcField}
            saveMapping={saveMapping}
            revvField={item}
            searchInput={searchInput}
            filterState={filterState}
            showMenuType={showMenuType}
          />
          <div className="assigned-sf-gap">
            <i>
              <FontAwesomeIcon
                icon={["far", "arrow-right"]}
                className="assigned-mapping-arrow"
                color="#b3c3da"
              />
            </i>
          </div>
          <div
            // onDrop={
            //   addFieldAllowed && draggedType === FORM_FIELD
            //     ? event => _dropFormField(event)
            //     : () => {}
            // }
            // onDragOver={_onDragOver}
            className="assigned-sf-formfields">
            {
              item && item.id && (
                <RevvField
                  key={
                    item.sub_field
                      ? `${item.label}-${item.sub_field}`
                      : item.label
                  }
                  title={
                    item.sub_field
                      ? `${item.label}-${item.sub_field}`
                      : item.label
                  }
                  revvFieldID={item.id}
                  revvSubField={item.sub_field || ""}
                  // removeField={removeField}
                  isRemoveAllowed
                />
              )
              // : (
              //   <AddNewField
              //     handleAddNewField={_addNewFormField}
              //     fieldList={unusedRevvFields}
              //   />
              // )
            }
          </div>
          <div className="assigned-sf-actions">
            <div
              onKeyDown={() => {}}
              tabIndex="0"
              role="button"
              onClick={() =>
                // checkTransformPopup ? openTransformPopup : () => {}
                _checkTransformPopup(item, "click")
              }
              className="assigned-sf-action">
              <Tooltip
                placement="bottom"
                align={{
                  offset: [0, 3],
                }}
                overlay={`${
                  _checkTransformPopup(item, "overlay")
                    ? "Transform"
                    : "Fields should not be empty"
                }`}>
                <FontAwesomeIcon icon={["far", "cog"]} className="" />
              </Tooltip>
            </div>
            <div
              onKeyDown={() => {}}
              tabIndex="0"
              role="button"
              onClick={() => _deleteConnection(item)}
              className="assigned-sf-action">
              <Tooltip
                placement="bottom"
                align={{
                  offset: [0, 3],
                }}
                overlay={"Delete"}>
                <FontAwesomeIcon icon={["far", "trash-alt"]} />
              </Tooltip>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = ({
  FieldsSettingStore: {
    fieldsList,
    draggedType,
    draggedFieldID,
    draggedFieldSubType,
    revvFieldDefs,
    revvFieldIDsWithInternalField,
    objectFieldsMapping,
    signerIDsWithInternalField,
    metaFieldIDsWithInternalField,
    tableIDsWithInternalField,
    tableIdsList,
  },
}) => ({
  fieldsList,
  draggedType,
  draggedFieldID,
  draggedFieldSubType,
  revvFieldDefs,
  revvFieldIDsWithInternalField,
  objectFieldsMapping,
  signerIDsWithInternalField,
  metaFieldIDsWithInternalField,
  tableIDsWithInternalField,
  tableIdsList,
});

export default connect(mapStateToProps, null)(RevvFieldMapperBlock);
